import React, { FC } from "react";
import { useField } from "formik";
import { IFormField } from "src/@types/form";
import { FormField } from ".";
import { SingleButtonSelector } from "../ButtonSelector/SingleButtonSelector";

export const SingleButtonSelectorField: FC<IFormField> = ({
  options,
  fieldClassName,
  labelClassName,
  className,
  id,
  label,
  name,
}) => {
  const fieldId = id || name;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fieldProps, _, fieldHelpers] = useField<string>(fieldId);

  const { value } = fieldProps;
  const { setValue } = fieldHelpers;

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      label={label}
      labelFor={fieldId}
    >
      <SingleButtonSelector
        options={options}
        activeValue={value}
        setActiveValue={setValue}
        className={className}
      />
    </FormField>
  );
};
